exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dmb-web__CropWaterLegend__legendContainer__2w-6E {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  max-height: calc(100% - 30px);\n}", ""]);

// exports
exports.locals = {
	"legendContainer": "dmb-web__CropWaterLegend__legendContainer__2w-6E"
};